import CollapsibleSection_vue_vue_type_script_setup_true_lang_default from "./CollapsibleSection.vue.script.js";
//#region src/v2/components/layout/CollapsibleSection.vue
var CollapsibleSection_default = CollapsibleSection_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { CollapsibleSection_default as default };

//# sourceMappingURL=CollapsibleSection.vue.js.map